module.exports = __webpack_public_path__ + "img/right-desktop.7440a3e1.jpeg";